export default __webpack_public_path__ + "static/media/PauseButtonIcon.0837ad3a.svg";